var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.13638,
    height: 77.13638,
    viewBox: "0 0 77.13638 77.13638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;fill-rule:evenodd;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.56819,0C17.28112,0,0,17.28112,0,38.56819s17.28112,38.56819,38.56819,38.56819,38.56819-17.28112,38.56819-38.56819S59.85526,0,38.56819,0ZM59.09097,40.63416c.72817-.43389,1.17164-1.21959,1.17164-2.06578s-.44343-1.63189-1.17164-2.06578l-28.92614-17.35569c-.74224-.44846-1.67026-.46051-2.42735-.03139-.75452.42661-1.2221,1.22936-1.2221,2.09715v34.71137c0,.86778.46754,1.67052,1.2221,2.09715.75703.42912,1.68511.41707,2.42735-.03139l28.92614-17.35565Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.154d5e962f34e3c8d9d677f0338a9949.svg";
export { ForwardRef as ReactComponent };